module.exports = __webpack_public_path__ + "media/images/lb/077-9561d8607ec674f12def18c51eb5c467.svg";